/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external_load_coordination': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7.26 3.5v2.265a1 1 0 01-1 1H4a1 1 0 00-1 1V20.25a1 1 0 001 1h12a1 1 0 001-1V19M12.74 3.5v2.265a1 1 0 001 1H16a1 1 0 011 1V12" _stroke="currentColor" stroke-width="1.5"/><path pid="1" d="M6.5 15.688V10m2.297 5.688v-1.241a1 1 0 00-.412-.809l-.791-.575H6.5v-.438h1.094l.791-.575a1 1 0 00.412-.81V10M11.703 15.687v-5.033H14" _stroke="currentColor" stroke-width="1.5"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M14.75 16.586V19h-1.5v-2.414c0-.966.784-1.75 1.75-1.75h4.232l-1.271-1.315 1.078-1.042 3.022 3.126-3.04 2.935-1.042-1.08 1.164-1.124H15a.25.25 0 00-.25.25z" _fill="currentColor"/><path pid="3" d="M6 3h8" _stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
  }
})
